import { render, staticRenderFns } from "./AddNewCard.vue?vue&type=template&id=67ad74f6&scoped=true&"
import script from "./AddNewCard.vue?vue&type=script&lang=js&"
export * from "./AddNewCard.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCard.vue?vue&type=style&index=0&id=67ad74f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad74f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDialog,VTextField})
